import type { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from '@root/src/stores';
import LeaveFeedbackModal from '.';

const LeaveFeedbackModalRoot: FC = observer(() => {
  const { modalsStore } = useStores();
  const { leaveFeedback, closeLeaveFeedback } = modalsStore;

  if (!leaveFeedback) {
    return null;
  }

  return (
    <LeaveFeedbackModal
      isPopupOpened
      popupStateHandler={closeLeaveFeedback}
      {...leaveFeedback}
    />
  );
});

export default LeaveFeedbackModalRoot;
